import { datadogRum } from '@datadog/browser-rum';
import config from '../../config';

export const initDatadogRum = () => {
  if (config.datadogApplicationId && config.datadogClientToken) {
    datadogRum.init({
      applicationId: config.datadogApplicationId,
      clientToken: config.datadogClientToken,
      site: 'datadoghq.eu',
      service: 'seo-landing-pages',
      version: config.version,
      env: config.deployedEnvironment,
      trackUserInteractions: true,
      trackFrustrations: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [/https:\/\/[A-Za-z]*-*api-[A-Za-z]*\.togather\.com/],
    });

    datadogRum.startSessionReplayRecording();
  }
};

export const captureError = (error, context) =>
  datadogRum.addError(error, context);
